<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "1.5rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><circle cx="16.5" cy="20" r="2"/><circle cx="9.5" cy="20" r="2"/><path d="M22.5 6.5a4.49 4.49 0 00-8.95-.5H6.71l-.59-2.25a1 1 0 00-1-.75H3a1 1 0 000 2h1.38l2.68 10.25A1 1 0 008 16h10a1 1 0 001-.76l1.17-4.67v-.14A4.5 4.5 0 0022.5 6.5zM8.8 14L7.23 8h6.55A4.49 4.49 0 0018 11l-.75 3zm9.2-4a3.5 3.5 0 113.5-3.5A3.5 3.5 0 0118 10z"/><path d="M20 6h-1.5V4.5a.5.5 0 00-1 0V6H16a.5.5 0 000 1h1.5v1.5a.5.5 0 001 0V7H20a.5.5 0 000-1z"/></svg>